const data = [
  {
    responsive_id: '',
    id: 95,
    full_name: 'Edwina Ebsworth',
    post: 'Human Resources Assistant',
    email: 'eebsworth2m@sbwire.com',
    city: 'Puzi',
    start_date: '09/27/2018',
    amount: 19586.23,
    age: '27',
    transaction_no: 1,
    total_transaction: 4,
    experience: '2 Years',
    status: 1,
  },
  {
    responsive_id: '',
    id: 1,
    full_name: "Korrie O'Crevy",
    post: 'Nuclear Power Engineer',
    email: 'kocrevy0@thetimes.co.uk',
    city: 'Krasnosilka',
    start_date: '09/23/2016',
    amount: 23896.35,
    age: '61',
    transaction_no: 2,
    total_transaction: 4,
    status: 2,
  },
  {
    responsive_id: '',
    id: 7,
    full_name: 'Eileen Diehn',
    post: 'Environmental Specialist',
    email: 'ediehn6@163.com',
    city: 'Lampuyang',
    start_date: '10/15/2017',
    amount: 18991.67,
    age: '59',
    transaction_no: 2,
    total_transaction: 4,
    status: 3,
  },
  {
    responsive_id: '',
    id: 11,
    full_name: 'De Falloon',
    post: 'Sales Representative',
    email: 'dfalloona@ifeng.com',
    city: 'Colima',
    start_date: '06/12/2018',
    amount: 19252.12,
    age: '30',
    transaction_no: 3,
    total_transaction: 4,
    status: 3,
  },
  {
    responsive_id: '',
    id: 3,
    full_name: 'Stella Ganderton',
    post: 'Operator',
    email: 'sganderton2@tuttocitta.it',
    city: 'Golcowa',
    start_date: '03/24/2018',
    amount: 13076.28,
    age: '66',
    transaction_no: 3,
    total_transaction: 4,
    status: 3,
  },
  {
    responsive_id: '',
    id: 5,
    full_name: 'Harmonia Nisius',
    post: 'Senior Cost Accountant',
    email: 'hnisius4@gnu.org',
    city: 'Lucan',
    start_date: '08/25/2017',
    amount: 10909.52,
    age: '33',
    transaction_no: 0,
    total_transaction: 4,
    status: 2,
  },
  {
    responsive_id: '',
    id: 6,
    full_name: 'Genevra Honeywood',
    post: 'Geologist',
    email: 'ghoneywood5@narod.ru',
    city: 'Maofan',
    start_date: '06/01/2017',
    amount: 17803.8,
    age: '61',
    transaction_no: 0,
    total_transaction: 4,
    status: 1,
  },
  {
    responsive_id: '',
    id: 4,
    full_name: 'Dorolice Crossman',
    post: 'Cost Accountant',
    email: 'dcrossman3@google.co.jp',
    city: 'Paquera',
    start_date: '12/03/2017',
    amount: 12336.17,
    age: '22',
    transaction_no: 3,
    total_transaction: 12,
    status: 2,
  },
]

export default data
